module.exports = __webpack_public_path__ + "img/flagSpainRound.55e3dab1.png";